import createCommercial from "./beeTypes/commercial";
import createCommercialQueen from "./beeTypes/commercialQueen";
import createFurdland from "./beeTypes/furdland";
import createFurdlandQueen from "./beeTypes/furdlandQueen";
import createKozmanianQueen from "./beeTypes/kozmanianQueen";
import createKozUniversityQueen from "./beeTypes/kozUniversityQueen";
import createMaryEllenQueen from "./beeTypes/maryEllenQueen";
import createRoskQueen from "./beeTypes/roskQueen";
import createKozmanian from "./beeTypes/kozmanian";
import createKozUniversity from "./beeTypes/kozUniversity";
import createMaryEllen from "./beeTypes/maryEllen";
import createRosk from "./beeTypes/rosk";
import { hiveState, inventoryState, playerState } from "./state/stateManager";
import GainedItem from "./ui/gainedItem";
import { Resources } from "./Resources";

export function convertGameTime(gTime) {
  const min = Math.floor(gTime / 60000) % 60;
  const hours = Math.floor(gTime / 3600000) % 24;
  const days = Math.floor(gTime / 86400000);
  console.log("days ", days, " hours ", hours, " min ", min);
  return { days: days, hours: hours, min: min };
}
export function createNotification(info) {
  let noti;
  return {
    create: () => {
      noti = document.getElementById("hive-indication");
      noti.style.bottom = 0;
      noti.style.height = "60px";
      noti.style.padding = "10px";
      noti.style.display = "block";
      noti.innerHTML = `<p id="notification">${info}</p>`;
    },
    destroy: () => {
      noti = document.getElementById("hive-indication");
      noti.innerHTML = ``;
      noti.style.bottom = "-400px";
      noti.style.padding = "0";
      noti.style.display = "none";
    },
  };
}

export function getRandomBetween(min, max) {
  return Math.random() * (max - min) + min;
}
export function checkInspections(inspections) {
  // 10, 25, 50,100,250,500,1000
  let content = playerState.getContent();
  let achievements = content.achievements;

  if (inspections >= 10) {
    //check 10
    if (!achievements.includes("10Inspections")) {
      createGainedItem("Achievement: 10 Inspections!");
      achievements.push("10Inspections");
    }
  }
  if (inspections >= 25) {
    //check 25
    if (!achievements.includes("25Inspections")) {
      createGainedItem("Achievement: 25 Inspections!");
      achievements.push("25Inspections");
    }
  }
  if (inspections >= 50) {
    //check 50
    if (!achievements.includes("50Inspections")) {
      createGainedItem("Achievement: 50 Inspections!");
      achievements.push("50Inspections");
    }
  }
  if (inspections >= 100) {
    //check 100
    if (!achievements.includes("100Inspections")) {
      createGainedItem("Achievement: 100 Inspections!");
      achievements.push("100Inspections");
    }
  }
  if (inspections >= 250) {
    //check 250
    if (!achievements.includes("250Inspections")) {
      createGainedItem("Achievement: 250 Inspections!");
      achievements.push("250Inspections");
    }
  }
  if (inspections >= 500) {
    //check 500
    if (!achievements.includes("500Inspections")) {
      createGainedItem("Achievement: 500 Inspections!");
      achievements.push("500Inspections");
    }
  }
  if (inspections >= 1000) {
    //check 1000
    if (!achievements.includes("1000Inspections")) {
      createGainedItem("Achievement: 1000 Inspections!");
      achievements.push("1000Inspections");
    }
  }
}
export function addExperience(amount) {
  let content = playerState.getContent();
  content.experience = content.experience + amount;
  //sting tolerance starts at 5, when experience goes to 20 it goes to 10, experience 50 goes to 12, experience 100 goes to 14, exp
  if (content.experience < 20) {
    //set to 5
    content.stingTolerance = 3;
  } else if (content.experience >= 20 && content.experience < 50) {
    //set to 10
    content.stingTolerance = 5;
  } else {
    //greater than 50, add 2 for each additional 50
    let amountMoreThan50 = content.experience - 50;
    let iterations = amountMoreThan50 / 50;
    content.stingTolerance = 5 + Math.floor(2 * iterations);
  }
  console.log(
    "adding experience: ",
    amount,
    " stingTolerance: ",
    content.stingTolerance
  );
  playerState.setContent(content);
}
export function getZeal() {
  let content = playerState.getContent();
  if (content.stings.count < content.stingTolerance) {
    return true;
  } else {
    return false;
  }
}
export function startStingTimer(hive, location, camera, stingCallback) {
  let stingTendency = 0;
  if (location == "menu") {
    stingTendency = 0.2;
  } else if (location == "inspect") {
    stingTendency = 1;
  }
  let lastStung = hive.lastStung;
  let aggressionConst;
  if (
    hive.queenStats.aggression == undefined ||
    hive.queenStats.aggression == null
  ) {
    aggressionConst = hive.aggression;
  } else {
    aggressionConst = hive.queenStats.aggression;
  }
  let aggression = aggressionConst * stingTendency;

  // if (hive.lastStung == null || hive.lastStung == undefined){
  //   lastStung =
  // }
  let timer = null;
  return {
    start: () => {
      if (timer == null) {
        timer = setInterval(() => {
          let random = Math.random();
          console.log(
            "inside sting timer: last stung: ",
            hive.lastStung,
            "hive aggression: ",
            aggressionConst,
            " calculated aggression: ",
            aggression,
            " random: ",
            random
          );
          let hives = hiveState.getHives();
          let lastSmoked = 0;
          hives.forEach((hi) => {
            if (hi.birth == hive.birth) {
              lastSmoked = hi.lastSmoked;
            }
          });
          if (lastSmoked == null || lastSmoked == undefined) {
            lastSmoked = 0;
          }
          console.log("lastSmoked in stingTimer is: ", lastSmoked);
          if (new Date().getTime() - lastSmoked > 10000) {
            console.log("no smoke protection, going into sting calculations");
            if (aggression <= 0.2) {
              random = random * 1.8;
            } else if (aggression > 0.2 && aggression <= 0.5) {
              random = random * 1.5;
            } else if (aggression > 0.75) {
              random = random / 2;
            }
            console.log(
              "sting: random after fuckery: ",
              random,
              " aggression after calculations: ",
              aggression
            );
            if (random <= aggression) {
              gotStung(camera, stingCallback);
            }
          } else {
            console.log("not stinging, smoke protection");
          }
        }, 3000);
      }
    },
    stop: () => {
      console.log("stopping stingTimer");
      clearInterval(timer);
    },
  };
}
export function gotStung(camera, stingCallback) {
  console.log("got stung!");
  let stung = document.getElementById("stung");
  let places = ["hand", "finger", "leg"];
  let place = Math.floor(getRandomBetween(0, 3));
  console.log("stung place: ", place);
  stung.classList.add("stungActive");
  stung.innerHTML = `<h1>You Got Stung On The ${places[place]}!</h1>`;
  camera.shake(2, 2, 400);
  Resources.Error.play();
  //set player state stings
  let content = playerState.getContent();
  content.stings.count = content.stings.count + 1;
  content.stings.stings.push(new Date().getTime());
  addExperience(1);
  stingCallback();
  setTimeout(() => {
    stung.innerHTML = ``;
    stung.classList.remove("stungActive");
    stung.classList.add("stungNotActive");
    stung.style.opacity = 0;
  }, 1000);
}
export function roundDown(number) {
  const byTen = Math.floor(number / 10);
  const rounded = byTen * 10;
  return rounded;
}

export function getBrandAwarenessConversion(jars) {
  let content = playerState.getContent();
  let brandA = content.brandAwareness;
  let brandAwarenessFraction = brandA / 100;
  let jarsToAdd = Math.floor(20 * brandAwarenessFraction);
  jarsToAdd = jarsToAdd + jars;
  return jarsToAdd;
}
export function randomizeNPCLocations() {
  console.log("inside randomizeNpcLocations");
  let content = playerState.getContent();
  let npcs = [
    "liv",
    "kaison",
    "margie",
    "oldMan",
    "cowboy",
    "jackson",
    "linda",
    "ronald",
    "marvin",
    "kevin",
    "bill",
  ];
  let npcLocations = {};
  npcs.forEach((npc, i) => {
    let position = getRandomBetween(0, 3);
    position = Math.floor(position);
    let obj = { location: position };
    npcLocations[npc] = obj;
  });
  console.log("after randomization: ", npcLocations);
  content.npcLocations = npcLocations;
  playerState.setContent(content);
}
export function createGainedItem(item) {
  console.log("inside createGainedItem: ", item);
  let gained = new GainedItem();
  gained.addItem(item);
  console.log("added gained item: ", gained);
}
export function createConfirmation(question) {
  console.log("inside createConfirmation");
  return new Promise((res, rej) => {
    let confirmation = document.getElementById("confirmation");
    confirmation.style.display = "flex";
    confirmation.innerHTML = `<p>${question}</p>
      <div style="display:flex;flex-direction:row;"><button id="confirmYes" class="menuButton">Yes</button><button id="confirmNo" class="menuButton">No</button></div>
      
      `;
    let confirmYes = document.getElementById("confirmYes");
    let confirmNo = document.getElementById("confirmNo");
    confirmYes.onclick = () => {
      confirmation.style.display = "none";
      res(true);
    };
    confirmNo.onclick = () => {
      confirmation.style.display = "none";
      rej(false);
    };
  });
}
export function sendAlert(alert, callback) {
  console.log("sending alert: ", alert);
  let alertContainer = document.getElementById("alert");
  alertContainer.style.display = "flex";
  alertContainer.innerHTML = `<p>${alert}</p>`;

  setTimeout(() => {
    alertContainer.innerHTML = ``;
    alertContainer.style.display = "none";
  }, 1000);
}
export function checkHarvestFrameAmount() {
  let content = playerState.getContent();
  let inventory = inventoryState.getInventory();
  let harvestedFrames = inventory.harvestedHoney;

  if (harvestedFrames >= 10) {
    //check for 10 frame achievement
    if (!content.achievements.includes("10HoneyFrames")) {
      content.achievements.push("10HoneyFrames");
      createGainedItem("Achievement: Harvested 10 Frames!");
    }
  }
  if (harvestedFrames >= 50) {
    //check for 50 frame achievement
    if (!content.achievements.includes("50HoneyFrames")) {
      content.achievements.push("50HoneyFrames");
      createGainedItem("Achievement: Harvested 50 Frames!");
    }
  }
  if (harvestedFrames >= 100) {
    if (!content.achievements.includes("100oneyFrames")) {
      content.achievements.push("100HoneyFrames");
      createGainedItem("Achievement: Harvested 100 Frames!");
    }
  }
  if (harvestedFrames >= 500) {
    if (!content.achievements.includes("500HoneyFrames")) {
      content.achievements.push("500HoneyFrames");
      createGainedItem("Achievement: Harvested 500 Frames!");
    }
  }
}
export function checkFirstHarvest() {
  let content = playerState.getContent();
  if (!content.achievements.includes("firstHarvest")) {
    content.achievements.push("firstHarvest");
    createGainedItem("Achievement: First Harvest!");
    return true;
  } else {
    return false;
  }
}
export function checkFirstSale() {
  let content = playerState.getContent();
  if (!content.achievements.includes("firstSale")) {
    content.achievements.push("firstSale");
    createGainedItem("Achievement: First Sale!");
  }
}
export function checkFilledJars() {
  let inventory = inventoryState.getInventory();
  let jars = inventory.filledJars;
  let content = playerState.getContent();
  if (jars >= 20) {
    if (!content.achievements.includes("20Jars")) {
      content.achievements.push("20Jars");
      createGainedItem("Achievement: 20 Filled Jars!");
    }
  }
  if (jars >= 100) {
    if (!content.achievements.includes("100Jars")) {
      content.achievements.push("100Jars");
      createGainedItem("Achievement: 100 Filled Jars!");
    }
  }
  if (jars >= 200) {
    if (!content.achievements.includes("200Jars")) {
      content.achievements.push("200Jars");
      createGainedItem("Achievement: 200 Filled Jars!");
    }
  }
  if (jars >= 500) {
    if (!content.achievements.includes("500Jars")) {
      content.achievements.push("500Jars");
      createGainedItem("Achievement: 500 Filled Jars!");
    }
  }
  if (jars >= 1000) {
    if (!content.achievements.includes("1000Jars")) {
      content.achievements.push("1000Jars");
      createGainedItem("Achievement: 1000 Filled Jars!");
    }
  }
}
export function checkFirstInspection() {
  let content = playerState.getContent();
  if (!content.achievements.includes("firstInspection")) {
    content.achievements.push("firstInspection");
    createGainedItem("Achievement: First Inspection!");
  }
}
export function checkAllClasses() {}
export function harvestFrame(hiveStats, frame) {
  let framesToAdd = 1 * (frame.fillCompletion / 100);
  let inventory = inventoryState.getInventory();
  checkHarvestFrameAmount();
  checkFirstHarvest();

  inventory.harvestedHoney = inventory.harvestedHoney + framesToAdd;
  hiveStats.foodFrames.count = hiveStats.foodFrames.count - framesToAdd;
  let hives = hiveState.getHives();
  let newHives = [];
  hives.forEach((hive, i) => {
    if (hive.birth === hiveStats.birth) {
      newHives.push(hiveStats);
    } else {
      newHives.push(hive);
    }
  });
  hiveState.setHives(newHives);
  sendAlert(`Harvested ${framesToAdd} Frames!`);
  return true;
}
export function splitHive(hiveStats, splitStats) {
  console.log("inside splitHive: ", hiveStats, " splitStats", splitStats);
  //remove brood and queen cell if necessary

  //remove food

  //call createBees with appropriate stats
  let hiveToAdd;
  switch (hiveStats.queenStats.breed) {
    case "Commercial":
    case "commercial":
      hiveToAdd = createCommercial(
        { x: 1, y: 1 },
        splitStats.broodFrames,
        splitStats.broodFrames,
        `${hiveStats.queenStats.breed} Split`
      );
      break;
    case "Furdland":
    case "furdland":
      hiveToAdd = createFurdland(
        { x: 1, y: 1 },
        splitStats.broodFrames,
        splitStats.broodFrames,
        `${hiveStats.queenStats.breed} Split`
      );
      break;
    case "kozmanian":
    case "Kozmanian":
      hiveToAdd = createKozmanian(
        { x: 1, y: 1 },
        splitStats.broodFrames,
        splitStats.broodFrames,
        `${hiveStats.queenStats.breed} Split`
      );
      break;
    case "Koz University":
    case "KozUniversity":
    case "kozUniversity":
      hiveToAdd = createKozUniversity(
        { x: 1, y: 1 },
        splitStats.broodFrames,
        splitStats.broodFrames,
        `${hiveStats.queenStats.breed} Split`
      );
      break;
    case "Mary Ellen":
    case "maryEllen":
      hiveToAdd = createMaryEllen(
        { x: 1, y: 1 },
        splitStats.broodFrames,
        splitStats.broodFrames,
        `${hiveStats.queenStats.breed} Split`
      );
      break;
    case "Rosk":
    case "rosk":
      hiveToAdd = createRosk(
        { x: 1, y: 1 },
        splitStats.broodFrames,
        splitStats.broodFrames,
        `${hiveStats.queenStats.breed} Split`
      );
      break;
    default:
      break;
  }
  if (splitStats.queenCells.include) {
    hiveToAdd.queenCells = {
      lastChecked: hiveStats.queenCells.lastChecked,
      type: "requeen",
      count: 1,
      cells: [
        {
          index: hiveStats.queenCells.cells[0].index,
          stageDate: hiveStats.queenCells.cells[0].stageDate,
        },
      ],
    };
  }
  //set split to state
  console.log("splitHive: hiveToAdd:", hiveToAdd);
  hiveToAdd.queenStats.haveQueen = false;
  hiveToAdd.queenStats.laying = false;
  hiveToAdd.queenStats.virgin = false;
  let inventory = inventoryState.getInventory();
  inventory.splits.push(hiveToAdd);
  sendAlert("Split Hive!");
  //remove brood frame count
  hiveStats.broodFrames.count =
    hiveStats.broodFrames.count - splitStats.broodFrames;
  //remove brood frame frames
  hiveStats.broodFrames.frames.splice(0, splitStats.broodFrames);
  //remove food frames
  hiveStats.foodFrames.count =
    hiveStats.foodFrames.count - splitStats.foodFrames;
  //remove queen cell
  if (splitStats.queenCells.include) {
    hiveStats.queenCells.count = hiveStats.queenCells.count - 1;
    hiveStats.queenCells.cells.splice(0, 1);
  }
  let hives = hiveState.getHives();
  let newHives = [];
  for (let i = 0; i < hives.length; i++) {
    if (hives[i].birth == hiveStats.birth) {
      newHives.push(hiveStats);
    } else {
      newHives.push(hives[i]);
    }
  }
  hiveState.setHives(newHives);
  return true;
}
export function requeenHive(hiveStats, queen) {
  console.log("requeen: inside requeenHive: ", queen, hiveStats);
  let newQueen;
  switch (queen.breed) {
    case "commercial":
      newQueen = createCommercialQueen();
      break;
    case "furdland":
      newQueen = createFurdlandQueen();
      break;
    case "kozmanian":
      newQueen = createKozmanianQueen();
      break;
    case "kozUniversity":
      newQueen = createKozUniversityQueen();
      break;
    case "maryEllen":
      newQueen = createMaryEllenQueen();
      break;
    case "rosk":
      newQueen = createRoskQueen();
      break;
    default:
      break;
  }
  console.log("requeen: should replace queen with: ", newQueen);
  hiveStats.queenStats = newQueen;
  hiveStats.queenCells.count = 0;
  hiveStats.queenCells.cells = [];
  let hives = hiveState.getHives();
  let newHives = [];
  for (let i = 0; i < hives.length; i++) {
    if (hives[i].birth == hiveStats.birth) {
      newHives.push(hiveStats);
    } else {
      newHives.push(hives[i]);
    }
  }
  hiveState.setHives(newHives);
  let inventory = inventoryState.getInventory();
  let queens = inventory.queens;
  let removed = false;
  for (let i = 0; i < inventory.queens.length; i++) {
    if (inventory.queens[i].breed == queen.breed && !removed) {
      console.log("requeen: removing queen from inventory");
      queens.splice(i, 1);
      removed = true;
    }
  }
  inventory.queens = queens;
  sendAlert(`Requeened Hive With A ${queen.breed} Queen`);
  return "success";
}
export function removeBroodBox(hiveStats) {
  let hives = hiveState.getHives();
  console.log("hives from state: ", hives);
  let newHives = [];
  hives.forEach((hive, i) => {
    if (hive.birth == hiveStats.birth) {
      console.log("addBox: got hive: ", hive);
      let overall = hive.overallFrames.count;
      let boxes = hive.overallFrames.boxes;
      let queenAccess = hive.overallFrames.queenAccess;

      overall = overall - 10;
      boxes = boxes - 1;
      queenAccess = queenAccess - 10;
      hive.overallFrames.count = overall;
      hive.overallFrames.boxes = boxes;
      hive.overallFrames.queenAccess = queenAccess;
      console.log("addBox: altered hive: ", hive);

      newHives.push(hive);
      hiveStats = hive;
    } else {
      newHives.push(hive);
    }
  });
  console.log("setting hives: ", newHives);
  hiveState.setHives(newHives);
  return hiveStats;
}
export function getHiveSprite(hiveStats) {
  console.log("getHiveSprite: ", hiveStats);
  let sprite = "one";
  if (hiveStats.overallFrames.boxes == 1) {
    sprite = "one";
  } else if (
    hiveStats.overallFrames.boxes == 2 &&
    hiveStats.overallFrames.queenAccess == 20
  ) {
    sprite = "two";
  } else if (
    hiveStats.overallFrames.boxes == 2 &&
    hiveStats.overallFrames.queenAccess == 10
  ) {
    sprite = "oneOne";
  } else if (
    hiveStats.overallFrames.boxes == 3 &&
    hiveStats.overallFrames.queenAccess == 10
  ) {
    sprite = "oneTwo";
  } else if (
    hiveStats.overallFrames.boxes == 3 &&
    hiveStats.overallFrames.queenAccess == 20
  ) {
    sprite = "twoOne";
  } else if (
    hiveStats.overallFrames.boxes == 4 &&
    hiveStats.overallFrames.queenAccess == 10
  ) {
    sprite = "oneThree";
  } else if (
    hiveStats.overallFrames.boxes == 4 &&
    hiveStats.overallFrames.queenAccess == 20
  ) {
    sprite = "twoTwo";
  } else if (
    hiveStats.overallFrames.boxes == 5 &&
    hiveStats.overallFrames.queenAccess == 10
  ) {
    sprite = "oneFour";
  } else if (
    hiveStats.overallFrames.boxes == 5 &&
    hiveStats.overallFrames.queenAccess == 20
  ) {
    sprite = "twoThree";
  } else if (
    hiveStats.overallFrames.boxes == 6 &&
    hiveStats.overallFrames.queenAccess == 10
  ) {
    sprite = "oneFive";
  } else if (
    hiveStats.overallFrames.boxes == 6 &&
    hiveStats.overallFrames.queenAccess == 20
  ) {
    sprite = "twoFour";
  }
  return sprite;
}
export function getDescriptionPrice(type) {
  console.log("getDesc: ", type);
  let description, price;
  switch (type) {
    case "Commercial":
    case "commercial":
      console.log("getDesc: got commercial");
      description =
        "They build up quickly and put honey up like mad. They tend to swarm often, and usually have trouble managing mites.";
      price = { nuc: 200, package: 130, queen: 25 };
      break;
    case "Mary Ellen":
    case "maryEllen":
      console.log("getDesc: got mary Ellen");
      description =
        "Mite maulers with high disease resistance. They overwinter wonderfully, but can sometimes have trouble packing honey away.";
      price = { nuc: 250, package: 160, queen: 50 };
      break;
    case "Kozmanian":
    case "kozmanian":
      description =
        "Excellent build up and honey production. Sometimes lacking in mite and disease resistance.";
      price = { nuc: 240, package: 150, queen: 40 };
      break;
    case "Koz University":
    case "kozUniversity":
      description =
        "High mite resistance, great overwinter abilities. They can sometimes be a challenge to keep in the box.";
      price = { nuc: 250, package: 160, queen: 50 };
      break;
    case "Rosk":
    case "rosk":
      description =
        "Great overwinter bees, high mite resistance. Usually quite aggressive.";
      price = { nuc: 250, package: 160, queen: 50 };
      break;
    case "Furdland":
    case "furdland":
      description =
        "Quite variable. Mite resistance, honey production and brood production can all range from poor to wonderful. Take a chance!";
      price = { nuc: 150, package: 100, queen: 15 };
      break;
    default:
      break;
  }
  console.log("returning ", description, price);
  return { description: description, price: price };
}

export function addBroodBox(hiveStats) {
  console.log("addBox: hiveStats:", hiveStats);
  let hives = hiveState.getHives();
  console.log("addBox: ", hives);
  let newHives = [];
  hives.forEach((hive, i) => {
    if (hive.birth == hiveStats.birth) {
      console.log("addBox: got hive: ", hive);
      let overall = hive.overallFrames.count;
      let boxes = hive.overallFrames.boxes;
      let queenAccess = hive.overallFrames.queenAccess;
      overall = overall + 10;
      boxes++;
      queenAccess = queenAccess + 10;
      hive.overallFrames.count = overall;
      hive.overallFrames.boxes = boxes;
      hive.overallFrames.queenAccess = queenAccess;
      console.log("addBox: altered hive: ", hive);

      newHives.push(hive);
      hiveStats = hive;
    } else {
      newHives.push(hive);
    }
  });
  console.log("setting hives: ", newHives);
  hiveState.setHives(newHives);
  return hiveStats;
}
export function addHoneyBox(hiveStats) {
  let hives = hiveState.getHives();
  console.log("hives from state: ", hives);
  let newHives = [];

  hives.forEach((hive, i) => {
    if (hive.birth == hiveStats.birth) {
      console.log("addBox: got hive: ", hive);
      let overall = hive.overallFrames.count;
      let boxes = hive.overallFrames.boxes;
      overall = overall + 10;
      boxes++;
      hive.overallFrames.count = overall;
      hive.overallFrames.boxes = boxes;
      console.log("addBox: altered hive: ", hive);

      newHives.push(hive);
      hiveStats = hive;
    } else {
      newHives.push(hive);
    }
  });
  console.log("setting hives: ", newHives);

  hiveState.setHives(newHives);
  return hiveStats;
}

export function removeHoneyBox(hiveStats) {
  let hives = hiveState.getHives();
  console.log("hives from state: ", hives);
  let newHives = [];
  hives.forEach((hive, i) => {
    if (hive.birth == hiveStats.birth) {
      console.log("addBox: got hive: ", hive);
      let overall = hive.overallFrames.count;
      let boxes = hive.overallFrames.boxes;
      let queenAccess = hive.overallFrames.queenAccess;

      overall = overall - 10;
      boxes = boxes - 1;

      hive.overallFrames.count = overall;
      hive.overallFrames.boxes = boxes;
      hive.overallFrames.queenAccess = queenAccess;
      console.log("addBox: altered hive: ", hive);

      newHives.push(hive);
      hiveStats = hive;
    } else {
      newHives.push(hive);
    }
  });
  console.log("setting hives: ", newHives);
  hiveState.setHives(newHives);
  return hiveStats;
}
